import React from 'react'
import { Link, graphql } from 'gatsby'

import DefaultLayout from '../components/layout'
import SEO from '../components/seo'
import appendLinkToParagraph from '../utils/preview-text'

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.posts.edges
    const pinnedPosts = data.pinnedPosts.edges
    const { currentPage, numPages } = this.props.pageContext
    const isFirst = currentPage === 1
    const isLast = currentPage === numPages
    const prevPage = currentPage - 1 === 1 ? '' : (currentPage - 1).toString()
    const nextPage = (currentPage + 1).toString()
    
    return (
      <DefaultLayout>
        <SEO
          title={siteTitle}
          keywords={[
            `blog`,
            `fabisevich`,
            `swift`,
            `ios`,
            `design`,
            `indie`,
            `startup`,
            `writing`,
          ]}
        />
        <div className="content-box clearfix">
          {currentPage === 1 && (
            <article className="post" key="build-ms-posts-page">
              <div className="post-content">
                <h2 className="post-title">
                  <Link to="/build-ms-posts/">
                    Recent Blog Posts From Build.ms
                  </Link>
                </h2>

                <div className="post-metadata">Pinned</div>

                <p>
                  Here are some recent blog posts from{' '}
                  <a href="https://build.ms">build.ms</a>, where I make
                  technology accessible to everyone by sharing lessons about
                  engineering, product development, design, business, marketing,
                  and AI.&nbsp;
                  <Link
                    className="post-continuation-link"
                    to="/build-ms-posts/"
                  >
                    Continue Reading →
                  </Link>
                </p>
              </div>
            </article>
          )}

          {currentPage === 1 &&
            pinnedPosts.length > 0 &&
            pinnedPosts.map(({ node }) => {
              var previewText = appendLinkToParagraph(
                node.excerpt,
                node.fields.slug
              )

              return (
                <article className="post" key={node.fields.slug}>
                  <div className="post-content">
                    <h2 className="post-title">
                      <Link to={node.fields.slug}>
                        {node.frontmatter.title}
                      </Link>
                    </h2>

                    <div className="post-metadata">
                      Pinned · {node.frontmatter.date} | {node.timeToRead}{' '}
                      minute read
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: `${previewText}` }}
                    />
                  </div>
                </article>
              )
            })}

          {posts.map(({ node }) => {
            var previewText = appendLinkToParagraph(
              node.excerpt,
              node.fields.slug
            )

            return (
              <article className="post" key={node.fields.slug}>
                <div className="post-content">
                  <h2 className="post-title">
                    <Link to={node.fields.slug}>{node.frontmatter.title}</Link>
                  </h2>

                  <div className="post-metadata">
                    {node.frontmatter.date} | {node.timeToRead} minute read
                  </div>

                  <div dangerouslySetInnerHTML={{ __html: `${previewText}` }} />
                </div>
              </article>
            )
          })}

          <div className="container">
            <div className="pagination" role="navigation">
              {!isFirst && (
                <Link to={`/${prevPage}`} rel="prev" className="newer-posts">
                  ← Previous
                </Link>
              )}

              <span className="page-number">
                Page {currentPage} of {numPages}
              </span>

              {!isLast && (
                <Link to={`/${nextPage}`} rel="next" className="older-posts">
                  Next →
                </Link>
              )}
            </div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query blogPageQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    posts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
      filter: {
        frontmatter: {
          published: { ne: false }
          draft: { ne: true }
          pinned: { ne: true }
        }
      }
    ) {
      edges {
        node {
          excerpt(format: HTML)
          fields {
            slug
          }
          timeToRead
          frontmatter {
            date(formatString: "MMM D, YYYY")
            title
            tags
          }
        }
      }
    }
    pinnedPosts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: {
          published: { ne: false }
          draft: { ne: true }
          pinned: { eq: true }
        }
      }
    ) {
      edges {
        node {
          excerpt(format: HTML)
          fields {
            slug
          }
          timeToRead
          frontmatter {
            date(formatString: "MMM D, YYYY")
            title
            tags
          }
        }
      }
    }
  }
`
